import { useMemo } from "react";
import Icon, { COLORS, ICONS } from "../../general-ui/icon";
import { useDispatch } from 'react-redux';
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { Link, useLocation, useParams } from 'react-router-dom';
import classNames from "classnames";
import { PATHNAMES } from "../admin";
import { setPanelOpen } from '../../../store/actions/admin/event-panel';
import { getHomepageDefaultLanguage } from "../../../utils/get-language";
import { ParamsProps } from "../../live-event/live-event";
import './sidebar-nav.scss';

export default function EventNav(): JSX.Element {

	const { workingEvent, eventUuid, workingSession } = useTypedSelector(state => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		eventUuid: state.CreateEventReducer.workingEvent?.uuid,
		workingSession: state.CreateSessionReducer.workingSession
	}));

	const dispatch = useDispatch();

	const location = useLocation();
	const { pathname } = location;

	const params = useParams() as ParamsProps;
	const defaultLanguage = workingEvent?.sessions ? getHomepageDefaultLanguage() : "en";

	const language = params.language ?? defaultLanguage;

	// conditional routing for theme to keep the editor window in current view
	const themeNav: string = useMemo(() => {
		return pathname.includes("landing") ? "landing" : pathname.includes("session") && workingSession ? `session/${workingSession.uuid}/${workingSession.default_language}` : "";
	}, [pathname, workingSession]);

	return (
		<div className="event-nav">
			{eventUuid && <nav>
				<Link
					className={classNames({ active: pathname === PATHNAMES.Event.LandingLink(eventUuid, language) })}
					to={PATHNAMES.Event.LandingLink(eventUuid, language)}
					onClick={() => dispatch(setPanelOpen(true))}>
					<div className="icon"><Icon name={ICONS.DESKTOP_SLIM} size={24} color={pathname === PATHNAMES.Event.LandingLink(eventUuid, language) ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
					Landing
				</Link>
				<Link
					// have to use includes here so will show active when re-routed to tab
					className={classNames({ active: pathname.includes(PATHNAMES.Event.RegistrationLink(eventUuid, language)) })}
					to={PATHNAMES.Event.RegistrationLink(eventUuid, language)}
					onClick={() => dispatch(setPanelOpen(true))}>
					<div className="icon"><Icon name={ICONS.REGISTRATION} size={24} color={pathname.includes(PATHNAMES.Event.RegistrationLink(eventUuid, language)) ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
					Registration
				</Link>
				<Link
					className={classNames({ active: pathname === PATHNAMES.Event.EventLink(eventUuid) })}
					to={PATHNAMES.Event.EventLink(eventUuid)}
					onClick={() => dispatch(setPanelOpen(true))}>
					<div className="icon"><Icon name={ICONS.EVENTS_NAV} size={24} color={pathname === PATHNAMES.Event.EventLink(eventUuid) ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
					Event
				</Link>
				<Link
					// also using includes here as there are a few different theme paths
					className={classNames({ active: pathname.includes("theme") })}
					to={PATHNAMES.Event.ThemeLink(eventUuid, themeNav)}
					onClick={() => dispatch(setPanelOpen(true))}>
					<div className="icon"><Icon name={ICONS.THEME_PALETTE} size={24} color={pathname.includes("theme") ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
					Theme
				</Link>

				{/* FUTURE DEV - feature is not being implemented for MVP but will be used in the future, refactor to use links, currentNav & NAV_LABELS are deprecated */}
				{/* <div>
                    <button className={classNames({ selected: currentNav === NAV_LABELS.Comments })} onClick={() => handleClick(NAV_LABELS.Comments)}>
                        <Icon name={ICONS.TAB_CHAT} size={24} color={currentNav === NAV_LABELS.Comments ? COLORS.WHITE : COLORS.GRAY} />
                    </button>
                    {capitalize(NAV_LABELS.Comments)}
                </div> */}
				{/* FUTURE DEV - feature is not being implemented for MVP but will be used in the future, refactor to use links, currentNav & NAV_LABELS are deprecated */}
				{/* <div>
                    <button className={classNames({ selected: currentNav === NAV_LABELS.Versions })} onClick={() => handleClick(NAV_LABELS.Versions)}>
                        <Icon name={ICONS.VERSIONS} size={24} color={currentNav === NAV_LABELS.Versions ? COLORS.WHITE : COLORS.GRAY} />
                    </button>
                    {capitalize(NAV_LABELS.Versions)}
                </div> */}
				{/* FUTURE DEV - no settings currently but saving for possible future use */}
				{/* <Link
					className={classNames({ active: pathname === EVENTPATHS[NAV_LABELS.Settings] })}
					to={EVENTPATHS[NAV_LABELS.Settings]}
					onClick={() => dispatch(updateCurrentNav(NAV_LABELS.Settings))}>
					<Icon name={ICONS.SETTINGS_TRANSPARENT} size={24} color={pathname === EVENTPATHS[NAV_LABELS.Settings] ? COLORS.WHITE : COLORS.GRAY} />
					{capitalize(NAV_LABELS.Settings)}
				</Link> */}
			</nav>}
		</div>
	);
}